(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adaptive-chords"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-achords]').forEach(function (root) {
  var panel = root.querySelector('[data-achords-panel]');
  var countEl = root.querySelector('[data-achords-count]');
  var songsEl = root.querySelector('[data-achords-songs]');
  var fillEl = root.querySelector('[data-achords-fill]');
  var modeBtns = Array.from(root.querySelectorAll('[data-achords-mode]'));
  var audioBase = root.dataset.audioBase || '';
  if (!panel) return;

  var data = { chords: '', beginnerSongs: '', advancedSongs: '' };
  try {
    data = JSON.parse(root.querySelector('[data-achords-data]').textContent);
  } catch (e) { /* 保持默认 */ }

  // 每行 "主|小调|七和弦"
  var chords = (data.chords || '').split('\n').map(function (line) {
    var parts = line.split('|').map(function (s) { return s.trim(); });
    return { m: parts[0] || '', mn: parts[1] || '', s: parts[2] || '' };
  }).filter(function (c) { return c.m; });

  var chordAudio = null;
  var mode = 0;

  function playChord(name) {
    if (!audioBase) return;
    if (!chordAudio) chordAudio = new Audio();
    chordAudio.src = audioBase + name + '.m4a';
    chordAudio.currentTime = 0;
    chordAudio.play().catch(function () {});
  }

  function makeKey(name, delay) {
    var k = document.createElement('button');
    k.type = 'button';
    k.className = 'achords__key';
    k.textContent = name;
    k.addEventListener('click', function () {
      playChord(name);
      panel.querySelectorAll('.achords__key.is-lit').forEach(function (el) {
        el.classList.remove('is-lit');
      });
      k.classList.add('is-lit');
    });
    setTimeout(function () {
      k.classList.add('is-in');
    }, delay);
    return k;
  }

  function renderPanel(m) {
    panel.innerHTML = '';
    var rows;
    if (m === 7) {
      rows = [chords.map(function (c) { return c.m; })];
    } else {
      rows = [
        chords.map(function (c) { return c.s; }),
        chords.map(function (c) { return c.mn; }),
        chords.map(function (c) { return c.m; })
      ];
    }
    rows.forEach(function (names, ri) {
      var row = document.createElement('div');
      row.className = 'achords__row';
      names.forEach(function (name, i) {
        if (name) row.appendChild(makeKey(name, 30 + ri * 55 + i * 25));
      });
      panel.appendChild(row);
    });
  }

  function setMode(m) {
    if (mode === m) return;
    mode = m;
    modeBtns.forEach(function (btn) {
      btn.classList.toggle('is-on', parseInt(btn.dataset.achordsMode, 10) === m);
    });
    if (countEl) countEl.textContent = m;
    if (songsEl) songsEl.textContent = m === 7 ? data.beginnerSongs : data.advancedSongs;
    if (fillEl) fillEl.style.width = m === 7 ? '33%' : '100%';
    root.querySelectorAll('[data-achords-lbl]').forEach(function (lbl) {
      var key = lbl.dataset.achordsLbl;
      var on = (m === 7 && key === 'beginner') || (m === 21 && key === 'advanced');
      lbl.classList.toggle('is-on', on);
    });
    renderPanel(m);
  }

  modeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setMode(parseInt(btn.dataset.achordsMode, 10));
    });
  });

  setMode(7);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-cards"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-blog-cards]').forEach(function (root) {
  var pills = root.querySelectorAll('[data-filter]');
  var cards = root.querySelectorAll('[data-card]');
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');
      var filter = pill.dataset.filter;
      cards.forEach(function (card) {
        var show = filter === 'all' || card.dataset.category === filter;
        card.classList.toggle('is-hidden', !show);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creator-videos"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-creators]').forEach(function (root) {
  var thumbs = Array.from(root.querySelectorAll('[data-creator-thumb]'));

  function stopThumb(thumb) {
    var video = thumb.querySelector('[data-creator-video]');
    var overlay = thumb.querySelector('[data-creator-overlay]');
    if (video) video.pause();
    thumb.classList.remove('is-playing');
    if (overlay) {
      overlay.style.opacity = '1';
      overlay.style.pointerEvents = 'auto';
    }
  }

  thumbs.forEach(function (thumb) {
    var video = thumb.querySelector('[data-creator-video]');
    var overlay = thumb.querySelector('[data-creator-overlay]');
    if (!video || !overlay) return;

    video.addEventListener('loadedmetadata', function () {
      video.currentTime = 0.001;
    });

    overlay.addEventListener('click', function () {
      if (!video.paused) return;
      thumbs.forEach(function (other) {
        if (other !== thumb) stopThumb(other);
      });
      if (!video.getAttribute('src') && video.dataset.src) {
        video.src = video.dataset.src;
        video.load();
      }
      video.muted = false;
      video.play().catch(function () {
        video.muted = true;
        video.play().catch(function () {});
      });
      thumb.classList.add('is-playing');
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    });

    video.addEventListener('click', function () {
      if (!video.paused) stopThumb(thumb);
    });
    video.addEventListener('ended', function () {
      stopThumb(thumb);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-faq-accordion]').forEach(function (root) {
  root.querySelectorAll('[data-faq-item]').forEach(function (item) {
    var btn = item.querySelector('[data-faq-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      root.querySelectorAll('[data-faq-item].is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        var openBtn = openItem.querySelector('[data-faq-toggle]');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelectorAll('[data-site-header]').forEach(function (header) {
  var toggle = header.querySelector('[data-header-toggle]');
  var drawer = header.querySelector('[data-header-drawer]');
  if (!toggle || !drawer) return;

  function setOpen(open) {
    header.classList.toggle('site-header--open', open);
    drawer.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  toggle.addEventListener('click', function () {
    setOpen(!header.classList.contains('site-header--open'));
  });

  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });

  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      setOpen(false);
    });
  });
});

/* 语言切换器：Shopify 的 localization 表单没有提交按钮，需要 JS 提交。
   实现照搬官方文档的 LocalizationForm 自定义元素（键盘 Esc 关闭、失焦收起）。
   抽屉里那份用的是原生 submit 按钮，不依赖本段，JS 挂了也能切。 */
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[name="language_code"]');
        this.button = this.querySelector('button');
        this.panel = this.querySelector('ul');
        if (!this.input || !this.button || !this.panel) return;

        this.button.addEventListener('click', this.onButtonClick.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.querySelectorAll('a').forEach(
          function (item) {
            item.addEventListener('click', this.onSelect.bind(this));
          }.bind(this)
        );

        /* 点击外部关闭用 pointerdown 而不是按钮的 focusout。
           iOS Safari 点 <button> 不会稳定给焦点，原来的写法会在同一次
           点击里 focus → 打开 → 立刻 focusout(relatedTarget=null) → 关闭，
           表现为「点不动」。pointerdown 早于 click，且不受 iOS
           「click 不从非交互元素冒泡到 document」这个限制影响。 */
        this._onDocPointerDown = function (event) {
          if (!this.contains(event.target)) this.hide();
        }.bind(this);
        document.addEventListener('pointerdown', this._onDocPointerDown, { passive: true });
      }

      disconnectedCallback() {
        if (this._onDocPointerDown) {
          document.removeEventListener('pointerdown', this._onDocPointerDown);
        }
      }

      hide() {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', '');
      }

      onButtonClick(event) {
        /* 按钮位于 localization 表单渲染出的 form 内部，虽然是
           type="button"，仍显式阻断一下默认行为与冒泡。
           注意：本块里不要写 Liquid 标签语法，即使在 JS 注释里 ——
           解析器照样会当成真标签，导致「form 未闭合」的语法错误。 */
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      }

      toggle() {
        /* 不再调 this.button.focus()：iOS Safari 上它是那条 focusout
           竞态的触发源，而 aria-expanded 已经把状态告知了读屏。 */
        var willOpen = this.panel.hasAttribute('hidden');
        if (willOpen) {
          this.panel.removeAttribute('hidden');
        } else {
          this.panel.setAttribute('hidden', '');
        }
        this.button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      }

      onKeyUp(event) {
        if (event.code !== 'Escape') return;
        this.hide();
        this.button.focus();
      }

      onFocusOut(event) {
        /* relatedTarget 为 null 时不关闭 —— 那在 iOS 上是「焦点丢到了
           空处」，不是「移到了别的控件」。点击外部关闭已由 pointerdown
           接管，这里只服务键盘 Tab 离开的场景。 */
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.hide();
      }

      onSelect(event) {
        event.preventDefault();
        this.input.value = event.currentTarget.dataset.value;
        var form = this.querySelector('form');
        if (form) form.submit();
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-hero]').forEach(function (hero) {
  var video = hero.querySelector('[data-hero-video]');
  var fsButton = hero.querySelector('[data-hero-fullscreen]');
  if (!video) return;

  video.muted = true;
  video.defaultMuted = true;
  var heroInView = true;

  function play() {
    if (document.visibilityState === 'hidden' || !heroInView) return;
    video.play().catch(function () {});
  }
  video.addEventListener('canplay', play, { once: true });
  requestAnimationFrame(play);

  // 离屏暂停，回视口继续
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        heroInView = entry.isIntersecting;
        if (heroInView) play();
        else video.pause();
      });
    }, { threshold: 0.1 }).observe(hero);
  }

  // 页面从后台切回时恢复播放（IO 不会因 tab 可见性变化重新触发）
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') play();
  });

  if (!fsButton) return;

  function exitFallback() {
    hero.classList.remove('hero-home--fs-fallback');
    video.controls = false;
  }

  fsButton.addEventListener('click', function () {
    if (hero.classList.contains('hero-home--fs-fallback')) {
      exitFallback();
      return;
    }
    video.controls = true;
    video.play().catch(function () {});
    var request = video.requestFullscreen || video.webkitEnterFullscreen;
    if (request) {
      try {
        var result = request.call(video);
        if (result && result.catch) {
          result.catch(function () {
            hero.classList.add('hero-home--fs-fallback');
          });
        }
      } catch (e) {
        hero.classList.add('hero-home--fs-fallback');
      }
    } else {
      hero.classList.add('hero-home--fs-fallback');
    }
  });

  document.addEventListener('fullscreenchange', function () {
    if (!document.fullscreenElement) video.controls = false;
  });
  video.addEventListener('webkitendfullscreen', function () {
    video.controls = false;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') exitFallback();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instruments-f7"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-f7]').forEach(function (root) {
  var scroll = root.querySelector('[data-f7-scroll]');
  var layerA = root.querySelector('[data-f7-bg-a]');
  var layerB = root.querySelector('[data-f7-bg-b]');
  var items = Array.from(root.querySelectorAll('[data-f7-item]'));
  var useA = true;
  var currentAudio = null;
  var currentBtn = null;
  var down = false;
  var startX = 0;
  var startLeft = 0;
  var dragged = false;

  // 拖拽横向滚动
  if (scroll) {
    scroll.addEventListener('mousedown', function (e) {
      down = true;
      startX = e.pageX - scroll.offsetLeft;
      startLeft = scroll.scrollLeft;
      dragged = false;
    });
    window.addEventListener('mouseup', function () {
      down = false;
    });
    scroll.addEventListener('mousemove', function (e) {
      if (!down) return;
      e.preventDefault();
      var dx = e.pageX - scroll.offsetLeft - startX;
      if (Math.abs(dx) > 5) dragged = true;
      scroll.scrollLeft = startLeft - dx * 1.2;
    });
  }

  function preload(url, cb) {
    var img = new Image();
    img.onload = cb;
    img.onerror = cb;
    img.src = url;
  }

  function crossfadeTo(url) {
    if (!url) return;
    preload(url, function () {
      if (useA) {
        if (layerB) {
          layerB.style.backgroundImage = "url('" + url + "')";
          layerB.style.opacity = '1';
        }
        if (layerA) layerA.style.opacity = '0';
        useA = false;
      } else {
        if (layerA) {
          layerA.style.backgroundImage = "url('" + url + "')";
          layerA.style.opacity = '1';
        }
        if (layerB) layerB.style.opacity = '0';
        useA = true;
      }
    });
  }

  function setBtnState(btn, playing) {
    btn.dataset.playing = playing ? 'true' : 'false';
  }

  function stopAll() {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio = null;
    }
    if (currentBtn) {
      setBtnState(currentBtn, false);
      currentBtn = null;
    }
  }

  function activateItem(item) {
    items.forEach(function (x) {
      x.classList.remove('is-active');
    });
    item.classList.add('is-active');
    crossfadeTo(item.dataset.bgImg);
  }

  root.querySelectorAll('[data-f7-play]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var item = btn.closest('[data-f7-item]');
      var isPlaying = btn.dataset.playing === 'true';
      if (item) activateItem(item);
      stopAll();
      if (isPlaying) return;
      var url = btn.dataset.audio;
      if (!url) return;
      currentAudio = new Audio(url);
      currentAudio.play().catch(function () {});
      currentAudio.onended = function () {
        setBtnState(btn, false);
        currentBtn = null;
      };
      setBtnState(btn, true);
      currentBtn = btn;
    });
  });

  items.forEach(function (item) {
    item.addEventListener('click', function () {
      if (dragged) return;
      activateItem(item);
    });
  });

  var first = root.querySelector('[data-f7-item].is-active');
  if (first && first.dataset.bgImg && layerA) {
    preload(first.dataset.bgImg, function () {
      layerA.style.backgroundImage = "url('" + first.dataset.bgImg + "')";
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('[data-cart-form]') || document.getElementById('cart-form');
  if (!form) return;

  var totalEl = form.querySelector('[data-cart-total]');
  var currency = totalEl ? totalEl.dataset.currency : 'USD';

  function formatMoney(cents) {
    return new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function recalculate() {
    var grandTotal = 0;
    form.querySelectorAll('[data-cart-item]').forEach(function (row) {
      var unitPrice = parseInt(row.dataset.unitPrice, 10) || 0;
      var input = row.querySelector('.cart-qty__input');
      var qty = input ? parseInt(input.value, 10) || 0 : 0;
      var lineTotal = unitPrice * qty;
      grandTotal += lineTotal;
      var lineTotalEl = row.querySelector('[data-line-total]');
      if (lineTotalEl) lineTotalEl.textContent = formatMoney(lineTotal);
    });
    if (totalEl) totalEl.textContent = formatMoney(grandTotal) + ' ' + currency;
  }

  form.querySelectorAll('[data-qty-action]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('[data-cart-item]');
      var input = row && row.querySelector('.cart-qty__input');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      input.value = btn.dataset.qtyAction === 'plus' ? Math.min(10, val + 1) : Math.max(1, val - 1);
      recalculate();
    });
  });

  form.querySelectorAll('.cart-qty__input').forEach(function (input) {
    input.addEventListener('input', recalculate);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenes-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-scenes]').forEach(function (accordion) {
  var cards = Array.from(accordion.querySelectorAll('[data-scene-card]'));
  if (!cards.length) return;

  var mobileLayout = window.matchMedia('(max-width: 900px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var activeCard = cards[0];
  var visible = false;
  var hoverTimer = 0;

  function getVideo(card) {
    return card.querySelector('[data-scene-video]');
  }

  function ensureLoaded(video) {
    if (!video || video.src || !video.dataset.sceneSrc) return;
    video.src = video.dataset.sceneSrc;
    video.load();
  }

  function playActive(restart) {
    var video = getVideo(activeCard);
    if (!video || reducedMotion.matches || !visible) return;
    ensureLoaded(video);
    video.muted = true;
    if (restart) {
      try { video.currentTime = 0; } catch (e) { /* metadata 未就绪时忽略 */ }
    }
    video.play().catch(function () {});
  }

  function activate(card, scroll) {
    if (!card || card === activeCard) return;
    cards.forEach(function (item) {
      var isActive = item === card;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-expanded', String(isActive));
      if (!isActive) {
        var v = getVideo(item);
        if (v) v.pause();
      }
    });
    activeCard = card;
    playActive(true);
    if (scroll && mobileLayout.matches) {
      window.setTimeout(function () {
        var top = window.scrollY + card.getBoundingClientRect().top - 70;
        window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }, reducedMotion.matches ? 0 : 430);
    }
  }

  cards.forEach(function (card) {
    card.addEventListener('pointerenter', function () {
      if (mobileLayout.matches || card === activeCard) return;
      window.clearTimeout(hoverTimer);
      hoverTimer = window.setTimeout(function () {
        if (card.matches(':hover')) activate(card);
      }, 45);
    });
    card.addEventListener('click', function () {
      activate(card, true);
    });
    card.addEventListener('keydown', function (e) {
      if (e.target !== card || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      activate(card, true);
    });
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible = entry.isIntersecting;
        if (visible) playActive(false);
        else cards.forEach(function (c) { var v = getVideo(c); if (v) v.pause(); });
      });
    }, { threshold: 0.2 }).observe(accordion);
  } else {
    visible = true;
    playActive(false);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unique-features"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-uniqf]').forEach(function (root) {
  root.querySelectorAll('[data-uniqf-demo-open]').forEach(function (btn) {
    var key = btn.getAttribute('data-uniqf-demo-open');
    var modal = root.querySelector('[data-uniqf-modal="' + key + '"]');
    if (!modal) return;
    var video = modal.querySelector('[data-uniqf-demo-video]');

    function open() {
      modal.hidden = false;
      if (video && !video.getAttribute('src') && video.dataset.demoSrc) {
        video.src = video.dataset.demoSrc;
        video.load();
      }
      if (video) video.play().catch(function () {});
    }
    function close() {
      modal.hidden = true;
      if (video) video.pause();
    }

    btn.addEventListener('click', open);
    modal.querySelectorAll('[data-uniqf-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-chapters"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-video-chapters]').forEach(function (section) {
  var poster = section.querySelector('[data-vch-play]');
  var iframe = section.querySelector('[data-vch-iframe]');
  var media = section.querySelector('[data-vch-media]');
  var chapters = Array.from(section.querySelectorAll('[data-video-time]'));
  var videoId = section.dataset.videoId;
  if (!poster || !iframe || !media || !videoId) return;

  var currentTime = parseInt(section.dataset.defaultStart, 10) || 0;

  function setActive(selected) {
    chapters.forEach(function (chapter) {
      var active = chapter === selected;
      chapter.classList.toggle('is-active', active);
      if (active) chapter.setAttribute('aria-current', 'true');
      else chapter.removeAttribute('aria-current');
    });
  }

  function playFrom(start) {
    currentTime = Math.max(0, parseInt(start, 10) || 0);
    var params = new URLSearchParams({
      start: String(currentTime),
      autoplay: '1',
      playsinline: '1',
      rel: '0',
      modestbranding: '1'
    });
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?' + params.toString();
    iframe.hidden = false;
    poster.hidden = true;
    media.classList.add('is-playing');
  }

  poster.addEventListener('click', function () {
    playFrom(currentTime);
  });
  chapters.forEach(function (chapter) {
    chapter.addEventListener('click', function () {
      setActive(chapter);
      playFrom(chapter.dataset.videoTime);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
